module.exports = __webpack_public_path__ + "assets/img/img228.def42e04.png";